import React from 'react';
import { useTranslation } from '../hooks/useTranslation';
import LanguageSelector from '../components/LanguageSelector';
import './TermsPage.css';

const TermsPage = () => {
  const { t } = useTranslation();
  const title = t('terms.title', { fallback: 'Condizioni Generali di Acquisto' });
  const lastUpdateLabel = t('terms.last_update', { fallback: 'Ultimo aggiornamento:' });

  const sections = [
    { key: 'section_1', title: t('terms.section_1_title'), content: t('terms.section_1_content') },
    { key: 'section_2', title: t('terms.section_2_title'), content: t('terms.section_2_content') },
    { key: 'section_3', title: t('terms.section_3_title'), content: t('terms.section_3_content') },
    { key: 'section_4', title: t('terms.section_4_title'), content: t('terms.section_4_content') },
    { key: 'section_5', title: t('terms.section_5_title'), content: t('terms.section_5_content') },
    { key: 'section_6', title: t('terms.section_6_title'), content: t('terms.section_6_content') },
    { key: 'section_7', title: t('terms.section_7_title'), content: t('terms.section_7_content') },
    { key: 'section_9', title: t('terms.section_9_title'), content: t('terms.section_9_content') },
    { key: 'section_11', title: t('terms.section_11_title'), content: t('terms.section_11_content') },
    { key: 'section_12', title: t('terms.section_12_title'), content: t('terms.section_12_content') },
    { key: 'section_13', title: t('terms.section_13_title'), content: t('terms.section_13_content') },
    { key: 'section_14', title: t('terms.section_14_title'), content: t('terms.section_14_content') },
  ];

  return (
    <div className="terms-page">
      <div className="container">
        <header className="terms-header">
          <h1>{title}</h1>
          <p className="terms-updated">
            {lastUpdateLabel} <strong>27/11/2025</strong>
          </p>
        </header>

        <section className="terms-content">
          {sections.map((section) => (
            <div key={section.key} className="terms-section">
              <h2>{section.title}</h2>
              <p>{section.content}</p>
            </div>
          ))}
        </section>
      </div>

      <LanguageSelector />
    </div>
  );
};

export default TermsPage;

